import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

function NotFound() {
  return (
    <>
      <SEO 
        title="404 - 페이지를 찾을 수 없습니다"
        description="요청하신 페이지를 찾을 수 없습니다."
      />
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 200px)',
        textAlign: 'center',
        padding: '20px'
      }}>
        <h1 style={{ fontSize: '72px', margin: '0', color: '#d4af37' }}>404</h1>
        <h2 style={{ fontSize: '24px', margin: '20px 0' }}>페이지를 찾을 수 없습니다</h2>
        <p style={{ color: '#666', marginBottom: '30px' }}>
          요청하신 페이지가 존재하지 않거나 이동되었습니다.
        </p>
        <Link 
          to="/" 
          style={{
            padding: '12px 30px',
            backgroundColor: '#d4af37',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '4px',
            fontWeight: 'bold'
          }}
        >
          홈으로 돌아가기
        </Link>
      </div>
    </>
  );
}

export default NotFound;
